// Interfaces
import { IAccess, IUserRole } from '../interfaces/mailbox.interfaces';
import { IDropdownItem } from '../interfaces/general.interfaces';
// Enums
import { PermissionType, MailboxAccessType } from '../enums';

export const isAllowed = (access: IAccess, type: PermissionType): boolean => {
    return access && access.privileges?.length > 0 && access.permissions && access.permissions.includes(type);
};

export const isAllowedMultiple = (access: IAccess, firstType: PermissionType, secondType: PermissionType): boolean => {
    return access && access.permissions && access.permissions.includes(firstType && secondType);
};

export const getUserRole = (userRole: IUserRole): IDropdownItem => {
    return {
        key:
            userRole.ownerName === null
                ? 'intet navn'
                : userRole.role !== 'CITIZEN'
                ? `${userRole.ownerName}`
                : userRole.ownerName, //FREM-2193
        value: userRole.mailboxId,
        disabled: false,
        role: userRole.role,
        cvrNumber: userRole.ownerExternalId,
        privileges: userRole?.privileges,
        accessType: userRole?.accessType,
    };
};

export const getUserRoles = (userRoles: IUserRole[]): IDropdownItem[] => {
    if (localStorage.getItem('mailboxId')) {
        const userRolesWithoutCurrent = userRoles.filter((x) => x.mailboxId !== localStorage.getItem('mailboxId'));
        return userRolesWithoutCurrent.map((x) => getUserRole(x));
    }
    return userRoles.map((x) => getUserRole(x));
};

export const getFilteredUserRoles = (userRoles: IUserRole[]): IDropdownItem[] => {
    const userRolesWithoutCurrent = userRoles.filter((x) => x.mailboxId !== getCurrentUserRole(userRoles).mailboxId);
    return userRolesWithoutCurrent.map((x) => getUserRole(x));
};

export const getUserRoleOwnerAsDropDownItem = (userRoles: IUserRole[]): IDropdownItem => {
    const userRole = getCurrentUserRole(userRoles);
    return getUserRole(userRole);
};

export const findMailboxRole = (userRoles: Array<IUserRole>): Promise<IUserRole> => {
    return new Promise((r, e) => {
        const roleFindResult = getCurrentUserRole(userRoles);
        roleFindResult ? r(roleFindResult) : r(null);
    });
};

export const getCurrentUserRole = (userRoles: IUserRole[]): IUserRole => {
    let roleFindResult;
    if (localStorage.getItem('mailboxId')) {
        roleFindResult = userRoles.find((userRole) => userRole.mailboxId === localStorage.getItem('mailboxId'));
    } else {
        roleFindResult = userRoles.find((userRole) => userRole.accessType === MailboxAccessType.OWNER);
        //FREM-2193
        if (roleFindResult === undefined) {
            roleFindResult = userRoles.find(
                (userRole) => userRole.accessType === MailboxAccessType.PARTY_REPRESENTATIVE
            );
        }
    }
    return roleFindResult;
};

export const isCurrentUserRoleOwner = (userRoles: IUserRole[]): boolean => {
    if (localStorage.getItem('mailboxId')) {
        const roleFindResult = userRoles.find(
            (userRole) =>
                userRole.mailboxId === localStorage.getItem('mailboxId') &&
                userRole.accessType === MailboxAccessType.OWNER
        );
        if (roleFindResult) {
            return true;
        }
        return false;
    }

    return false;
};

export const isAccessPrivilageWriteOnly = (accessType: string[]) => {
    return !!(accessType?.length === 1 && accessType.includes(MailboxAccessType.MESSAGE_WRITE));
};
